import makeRequest from '.';

export const addFcmToken = (requestBody) => {
    return makeRequest({
        method: 'POST',
        uri: '/v1/users/fcm_token',
        body: JSON.stringify(requestBody)
    });
};
